import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { CSSTransition } from "react-transition-group";

const NotFound = () => {
  const [isImageVisible, setImageVisible] = useState(false);
  useEffect(() => {
    document.title = "404 - Страница не найдена";
    // window.history.replaceState({}, "", "/404"); // Меняем URL на /404
    setImageVisible(true);
  }, []);

  return (
    <div className="not-found text-center">
      <HelmetProvider>
        <Helmet>
          {/* <title>404 - Страница не найдена</title> */}
          {/* <meta name="robots" content="noindex, nofollow" /> */}
        </Helmet>
      </HelmetProvider>
      <div className="container">
        <div className="section-title">
          <h2>404 - Страница не найдена</h2>
          <p>Лифт на реставрации: запрошенная страница недоступна.</p>
          <CSSTransition
            in={isImageVisible}
            timeout={500}
            classNames="blur"
            unmountOnExit
          >
            <img
              src="static/img/404.webp"
              className="img-responsive"
              alt="Пустой лифт с табло, показывающим ошибку 404: страница не найдена"
            />
          </CSSTransition>
          <p><a href="/" className="link">Вернуться на главную</a></p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
